import { Button } from "@mui/material";
import { IconArrowBackUp } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


export function ReturnToButton({ path, label}) {
    const navigate = useNavigate()
    const { t } = useTranslation();

    const handleReturnTo= () => {
        navigate(path);
    }

    return (
        <Button
            color='primary'
            aria-label={label ?? t('backToOverview')}
            sx={{
                width: { xs: '100%', sm: 'auto' }
            }}
            startIcon={<IconArrowBackUp />}
            onClick={handleReturnTo}
        >
            {label ?? t('backToOverview')}
        </Button>
    )
}